"use client"

import { ClipboardCheck } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ClipboardCheckIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ClipboardCheckIcon = component(Icon)({ as: ClipboardCheck })
